module.exports = __webpack_public_path__ + "static/media/pinkglove.971a7dc5.svg";